import DateRange from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import {
  Typography,
} from '@mui/material';
import './styles.css';
// type ValuePiece = Date | null;

// type Value = ValuePiece | [ValuePiece, ValuePiece];

export default function MyApp({ title, onChange, value }) {

  return (
    <div>
          <Typography variant="h6" gutterBottom >
            {title}
          </Typography>
      <DateRange className='date-range-class' onChange={onChange} value={value} />
    </div>
  );
}